<template>
  <div class="comment-week">
    <div class="comment-week__header">
      <div class="comment-week__title">
        <div class="comment-week__title-text">Komentarz ogólny do jadłospisu</div>
      </div>
      <div v-if="editable && !editing" class="comment-week__action">
        <StyledButton :left-icon="empty ? 'add' : 'edit'" variant="outline" @click="emit('edit')">
          {{ empty ? 'Dodaj komentarz' : 'Edytuj komentarz' }}
        </StyledButton>
      </div>
    </div>
    <div v-if="editing" class="comment-week__edit">
      <BaseEditor :value="draft" @input="emit('update:draft', $event)" />
      <div class="comment-week__edit-actions">
        <StyledButton variant="outline" @click="emit('cancel')">Anuluj</StyledButton>
        <StyledButton @click="emit('save')">Zapisz</StyledButton>
      </div>
    </div>
    <div
      v-else-if="empty"
      class="comment-week__empty"
      :class="{ 'comment-week__empty--editable': editable }"
      @click="editable && emit('edit')"
    >
      Brak komentarza.<br>
      <template v-if="editable">
        Dodaj komentarz do jadłospisu, klikając w przycisk
        <span class="comment-week__empty-button"> + Dodaj komentarz </span>
        .
      </template>
    </div>
    <div
      v-else
      class="comment-week__content"
      :class="{ 'comment-week__content--editable': editable }"
      @click="editable && emit('edit')"
    >
      <div class="comment-week__content-text" v-html="comment" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import BaseEditor from '@/components/BaseEditor.vue'
  import { StyledButton } from '@/components/StyledButton'

  defineProps<{
    comment: string
    draft: string
    editing: boolean
    editable: boolean
    empty: boolean
  }>()
  const emit = defineEmits<{
    cancel: []
    edit: []
    save: []
    'update:draft': [value: string]
  }>()
</script>
